/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const PAYMENT_PLACE_ORDER = 'MFE/CHECKOUT/PAYMENT/PLACE_ORDER';
export const PAYMENT_PLACE_ORDER_COMPLETED = 'MFE/CHECKOUT/PAYMENT/PLACE_ORDER/COMPLETED';
export const APPLE_PAY_MERCHANT_PROCESS = 'MFE/CHECKOUT/PAYMENT/APPLE_PAY_MERCHANT_PROCESS';
